<template>
  <div class="layout-data-popup abs">
    <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
      <div v-if="openedPopup" @click="close" class="overlay abs"></div>
    </transition>
    <transition enter-active-class="animated fadeInRight" leave-active-class="animated fadeOutRight">
      <div v-if="openedPopup" class="window ui-scroll">
        <slot></slot>
        <div @click="close" class="close-button"><icon-close></icon-close></div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      openedPopup: false
    }
  },
  computed: {
/*    currentHash() {
      return this.$route.hash
    },
    opened() {
      return this.currentHash === `#${this.id}`
    }*/
  },
  components: {
    'icon-close': () => import('@/components/icon/icon-close'),
    'icon-success': () => import('@/components/icon/icon-success'),
    'ui-popup-form': () => import('@/components/ui/ui-popup-form'),
    'layout-popup': () => import('@/components/layout/layout-popup'),
    'layout-sent': () => import('@/components/layout/layout-sent'),
    'ui-button': () => import('@/components/ui/ui-button.vue'),
  },
  methods: {
    close() {
      //this.$router.push({ hash: undefined })
      this.openedPopup = false;
    }
  },
  created () {
    this.$bus.$on('openedPopup', (ids) => {
      if(this.id==ids) {
        this.openedPopup = true;
      }
    });
  }
}
</script>

<style lang="scss" scoped>
.layout-data-popup {
  position: fixed;
  z-index: 500;
  pointer-events: none;
  display: flex;
  justify-content: flex-end;
  & > * {
    pointer-events: all;
  }
}
.overlay {
  background: rgba(50, 59, 83, 0.8);
}
.window {
  margin: auto;
  width: 500px;
  max-width: 100%;
  padding: 3em 5em;
  background: #fff;
  position: relative;
  border-radius: 10px;
  z-index: 10;
  text-align: center;
  max-height: 80vh;
  &.smallPadding {
    padding: 2em;
  }
}
.close-button {
  position: absolute;
  right: 2em;
  top: 2em;
  cursor: pointer;
}
.success {
  svg {
    margin-bottom: 2em;
  }
  .ui-button {
    margin-top: 4em;
  }
}
@media screen and (max-width: 767px) {
  .window {
    padding: 2em 10px;
  }
}
</style>
<style>
  #dolyame-modal-body .modal__title {
    text-align: center;
  }
  #dolyame-modal-body .dolyame-modal__header {
    font-size: 32px;
    line-height: 38px;
    width: 100%;
    color: #000;
    margin-bottom: 16px;
    text-align: center;
  }
  #dolyame-modal-body .dolyame-modal__body-description {
    text-align: center;
  }
</style>